<template>
  <!-- todo-yanshi -->
  <div class="navbar">
    <div >


      <div class="top_left_logo"></div>
      <div class="top_right_info" >
        <el-dropdown trigger="click" style="color: black;cursor:pointer;" v-if="$store.state.menus && $store.state.menus[0] && $store.state.menus[0].name != '学员端'">
					<section class="msg_info"></section>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item>
                <div @click="toPage('/warning/conf')"><span >预警设置</span></div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div @click="toPage('/warning/record')"><span >预警短信发送记录</span></div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div @click="toPage('/warning/monitor')"><span >预警监控</span></div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown trigger="click" style="color: black;cursor:pointer;">
            <div class="user_info"></div>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item v-if="$store.state.menus && $store.state.menus[0] && $store.state.menus[0].name == '学员端'">
                  <div  @click="gotoStuInfo()"><span style="color: #555;font-size: 14px;">个人信息</span></div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="toPage('/user/changepwd?clearTabNav=true')"><span style="color: #555;font-size: 14px;">修改密码</span></div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
        
      </div>
      <div class="top_mid_info">
        <div class="role_info">{{nickname}}</div>
        <!-- <div class="time_info">上次登陆时间：12:33 3/21/2022 </div> -->
      </div>
      <exportFile ref="exportFile"></exportFile>
      <!-- <div style="display: inline-block;
          float: left;
          height: 100%;
          line-height: 50px;
          font-size: 18px;
          margin-left: 20px;
          /*font-family:;*/
          font-family: 微软雅黑;
        font-weight: 800;
        
      ">
          {{entName}} {{config.suffixName}}

      </div> -->

      <!-- <div style="text-align: center;width: 300px;display: inline-block;align-items: center">
        <notice-bar :message="notice" ></notice-bar>
      </div> -->
      <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container"
                 @toggleClick="toggleSideBar" style="display: none"/>
      <div class="right-menu customer_main">
        <!-- <i class="iconfont el-icon-user"></i>
        <i class="iconfont el-icon-message-solid"></i> -->
          <!-- <div @click="$refs.customer.show()" class="f messages item customer_item" to="" style="color: black">
            <span class="text">联系客服</span>
          </div> -->
        <!-- <router-link class="f helper item help_item" to="/helps" style="color: black">
          <div><span class="text">帮助中心</span>
          </div>
        </router-link> -->
        <div class="f topbar-account topbar-btn" v-if="false">


          <router-link class="f messages" to="/course/mall?clearTabNav=true"  style="color: black">
            <span class="icon font_family icon-book" style="font-size: 20px;margin-right: 5px"></span>
            <span style="font-size: 15px;">课程商城</span>
          </router-link>


          <router-link class="f messages" to="/course/platform?clearTabNav=true"
                       v-if="!config.includeMall && config.freeCourse" style="color: black">
            <span class="icon font_family icon-book" style="font-size: 20px;margin-right: 5px"></span>
            <span style="font-size: 15px;">平台课程</span>
          </router-link>
<!--          <nav-message></nav-message>-->
          

          <el-dropdown trigger="click" style="color: black;cursor:pointer;">
					<span class="el-dropdown-link userinfo-inner">
               <span class="icon font_family icon-guanliyuan" style="font-size: 20px;margin-right: 5px"></span>
            <span style="font-size: 15px;">
              {{ nickname }}
            </span>
						<i class="el-icon-arrow-down"></i>
					</span>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item>
                <div @click="toPage('/user/profile?clearTabNav=true')"><span style="color: #555;font-size: 14px;">个人信息</span></div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div @click="toPage('/user/changepwd?clearTabNav=true')"><span style="color: #555;font-size: 14px;">修改密码</span></div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <a class="message2" title="退出登录" @click="logout" style="margin-right: 30px;color: black">
            <span class="icon font_family icon-tuichu" style="font-size: 20px;margin-right: 5px"></span>
            <span style="font-size: 15px">退出</span>
          </a>
        </div>
      </div>
    </div>
    <customer ref="customer"></customer>
  </div>

</template>

<script>
import NoticeBar from '@/components/NoticeBar/index.vue'
import Breadcrumb from '@/components/comm/Breadcrumb'
import Hamburger from '@/components/comm/Hamburger'
import navMessage from "@/components/message/NavMessage";
import MallHome from '@/components/comm/MallHome/index.vue'
import MallCourse from '@/components/comm/MallCourse/index.vue'
import KeFu from '@/components/comm/KeFu/index.vue'
import HandBook from '@/components/comm/HandBook/index.vue'
import API from '@/api/api_user';
import config from '@/config/config.js'
import exportFile from "@/pages/trainingManagement/component/exportFile/exportFile";
import customer from '@/components/customer/index.vue'

import API_ENT from '@/api/api_enterprisebase';

import {bus} from '../../bus.js';


export default {
  components: {
    NoticeBar,
    Breadcrumb,
    Hamburger,
    navMessage,
    MallHome,
    MallCourse,
    KeFu,
    HandBook,
    exportFile,
    customer
  },
  data() {
    return {
      notice:"1.禁止同一学员账户在另一台终端设备同时登陆，当登录时将当前终端设备自动签退；2.禁止同一终端设备同一时刻出现两名学员登录学习的，当多用户登录时自动签退前者；3.禁止学员同一时刻学习两个及以上的课程；4.禁止学员使用插件拖拽播放进度等",
      config: config,
      dialogVisible: false,
      nickname: undefined,
      entName:undefined,
      studentInfo: false,
    }
  },
  computed: {
    sidebar() {
      return this.$store.state.sidebar;
    }
  },
  mounted() {
    this.initPerms()
    this.getEntName();
    // if(this.$store.state.menus && this.$store.state.menus[0].name == '学员端') {
    //     this.studentInfo = true;
    //   }
  },
  created() {
    bus.$on('changeCurrentUserName', (data) => {
      console.log('change current user name, data', data);
      this.nickname = data;
    });
  },
  methods: {
    //获取企业名称
    getEntName() {
      let than = this;
      API_ENT.findEntById(JSON.parse(localStorage.getItem('userinfo')).enterpriseId).then(res => {
        if (res && res.code == 0) {
          than.entName = res.ent.companyName;
          console.log(than.entName)
        }
      });
    },
    toPage(url) {
      this.$router.push(url);
    },
    gotoStuInfo() {
      console.log(this.$store.state.menus)
      this.studentInfo = false;
      if(this.$store.state.menus && this.$store.state.menus[0] && this.$store.state.menus[0].name == '学员端') {
        this.studentInfo = true;
        this.$router.push('/individual')
      }
    },
    /**
     * 跳转到帮助手册页
     */
    toHelp() {
      window.open(this.config.files.helpFile);
    },
    initPerms() {
      let that = this;
      API.tokenUser().then(function (result) {
        console.log(result)
        that.nickname = result.username;
        localStorage.setItem('perms', JSON.stringify(result.perms));
      }).catch(() => {
        console.log("================进")
        localStorage.removeItem('access-token');
        that.$router.go('/login'); //用go刷新
      });
    },
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    logout() {
      let that = this;
      this.$confirm('确认退出吗?', '提示', {
        confirmButtonClass: 'el-button--warning'
      }).then(() => {
        that.loading = true;
        let token = window.localStorage.getItem('access-token');
        API.logout({
          token: token
        }).then(function (res) {
          window.localStorage.removeItem('access-token');
          window.localStorage.removeItem('menus');
          that.$router.push('/login'); //跳转 回登陆页面
        });
      })
        .catch(() => {
        });
    },
  }
}
</script>

<style lang="scss" scoped>
.f{
  background-color: #d6e6ff;
}
.topbar-account {
  font-size: 16px;

  .sise {
    color: #fff;
    margin-right: 30px;

    i {
      margin-right: 5px;
      margin-left: 10px;
    }
  }

  .fourfigure {
    color: #fff;
    margin-right: 30px;

    i {
      display: inline-block;
      margin-right: 5px;
    }
  }

  .video {
    color: #fff;
    margin-right: 50px;

    i {
      display: inline-block;
      margin-right: 5px;
    }
  }

  .message {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-left: 10px;
    background-size: 30px;
  }

  .message2 {
    display: inline-block;
    color: #fff;
    margin-left: 10px;
    cursor: pointer;
  }

  .messages {
    margin-right: 15px;
    color: #fff;

    i {
      font-size: 20px;
      margin-right: 6px;
    }
  }

  .helper {
    margin-right: 20px;
    color: #fff;

    i {
      font-size: 20px;
      margin-right: 6px;
    }
  }
}


.navbar-itme {

  padding: 0 15px;
  display: inline-block;
  vertical-align: middle;
  width: 125px;
  height: 50px;
  border: black 0px solid;
  line-height: 20px
}


.navbar {

  height: 90px;
  overflow: hidden;
  position: relative;
  //background: #fff;
  //background-color: #fff;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    font-size: 18px;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.customer_main{
  padding-top: 22px;
  .item{
    display: inline-block;
    background: none;
    padding-right: 15px;
    padding-left: 24px;
  }
  .text{
    font-size: 14px;
    color: #8C8FA5;
  }
  .customer_item{
    background: url(../../assets/images/newImg/icon01.png) no-repeat 0 center;
    background-size: 17px;
  }
  .help_item{
    background: url(../../assets/images/newImg/icon02.png) no-repeat 0 center;
    background-size: 17px;}
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue